import {
  Cog,
  ShieldCheck,
  Boxes,
  PencilRuler,
  Lightbulb,
  HardHat,
  Building2,
  SearchCheck,
  ClipboardCheck,
  GraduationCap,
  Activity,
} from "lucide-react";

export const iconMap = {
  Cog,
  ShieldCheck,
  Boxes,
  PencilRuler,
  Lightbulb,
  HardHat,
  Building2,
  SearchCheck,
  ClipboardCheck,
  GraduationCap,
  Activity,
};

export const Icon = ({ name, ...props }) => {
  const Cmp = iconMap[name] || Cog;
  return <Cmp {...props} />;
};

export default Icon;
